import React, { Suspense } from "react";
import { IDrawerActions } from "design-system/src/HOC/withDrawer";
import SuspenseAfterInteraction from "@src/lib/AfterInteraction/SuspenseAfterInteraction";
const ModalRouteNavigation = React.lazy(() => import("./ModalRouteNavigation"));

const createModalRouteNavigation =
  (hash?: string) => (open: boolean, actions: IDrawerActions) => {
    return (
      <SuspenseAfterInteraction>
        <Suspense>
          <ModalRouteNavigation open={open} hash={hash} actions={actions} />
        </Suspense>
      </SuspenseAfterInteraction>
    );
  };

export default createModalRouteNavigation;
